import { gql, TypedDocumentNode } from "@apollo/client";

export type PersonProfileDocument = {
  id: string;
  name: string;
  description?: string | null;
  category: string;
  filename?: string | null;
  url?: string | null;
  privacyRestricted: boolean;
  createdAt: string;
};

export type PersonProfileDocumentCategory = {
  value: string;
  label: string;
  uploadable: boolean;
};

export type PersonProfileDocumentsQueryResponse = {
  person: {
    id: string;
    profileDocuments: PersonProfileDocument[];
  };
  personProfileDocumentCategories: PersonProfileDocumentCategory[];
};

export type PersonProfileDocumentsQueryVariables = {
  pgaId: string;
};

export const PERSON_PROFILE_DOCUMENT_LIBRARY_QUERY: TypedDocumentNode<
  PersonProfileDocumentsQueryResponse,
  PersonProfileDocumentsQueryVariables
> = gql`
  query PersonProfileDocumentLibrary($pgaId: ID!) {
    person(pgaId: $pgaId) {
      id
      profileDocuments {
        id
        name
        description
        category
        filename
        url
        privacyRestricted
        createdAt
      }
    }
    personProfileDocumentCategories {
      value
      label
      uploadable
    }
  }
`;
